import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/**
 * Compose Tailwind class strings, deduplicate conflicting utilities.
 * Standard shadcn helper — every primitive imports this.
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=utils.js.map